import React from 'react';
import styles from '../../styles/home.module.css';

function SectionOne() {
    return (
        <section className={styles.SectionNew} id="new">
            <div className={styles.InNew}>
                <h2>Novosti v aplikaciji</h2>
                <div className={styles.Cards}>
                    <div className={styles.Card}>
                        <div className={styles.InCard}>
                            <img className={styles.Image} src={require('../../images/teza.jpg')} alt="Slika ko dodamo težo" />
                        </div>
                        <h5>NOVOST</h5>
                        <p>Dodali smo novo funkcijo za beleženje vaše teže</p>
                    </div>
                    <div className={styles.Card}>
                        <div className={styles.InCard}>
                            <img className={styles.Image} src={require('../../images/klepet.jpg')} alt="Zajem slike - klepeta pri aplikaciji" />
                        </div>
                        <h5>NOVOST</h5>
                        <p>Sedaj klepet z zdravnikom, kar preko mobilnega telefona</p>
                    </div>
                    <div className={styles.Card}>
                        <div className={styles.InCard}>
                            <img className={styles.Image} src={require('../../images/lekarne.jpg')} alt="Google maps lekarne" />
                        </div>
                        <h5>NOVOST</h5>
                        <p>Rabite pomoč pri iskanju lekarn ali zdravstvenih domovov?</p>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default SectionOne;